function getOpt(dataObj) {
  let xData = dataObj.typeId;
  let y1Data = dataObj.myValue;
  let y2Data = dataObj.otherValue;
  xData = xData.map((i) => {
    let name;
    if (i == "CO2") {
      name = i + " (t/吨钢)";
    } else {
      name = i + " (kg/吨钢)";
    }
    return name;
  });

  return {
    backgroundColor: "transparent",
    tooltip: {
      show: true,
      trigger: "axis",
      backgroundColor: "rgba(4, 21, 39, 1)",
      borderWidth: 0,
      textStyle: {
        color: "#fff",
      },
      formatter: function (datas) {
        let res = datas[0].name + "<br/>";
        let val;
        let length = datas.length;
        let i = 0;
        let colorList = ['#A8FFA4','#F0B58E']
        for (; i < length; i++) {
          val = datas[i].value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
          res +=
            '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' +
            colorList[i] +
            ';"></span>' +
            datas[i].seriesName +
            "：" +
            val +
            "<br/>";
        }
        return res;
      },
    },
    legend: {
      show: true,
      icon: "roundRect",
      itemWidth: 26,
      itemHeight: 16,
      right: "2%",
      top: "8%",
      itemGap: 15.5,
      textStyle: {
        fontSize: 14,
        color: "rgba(255,255,255,1)",
        padding: [2, 0, 0, 0],
      },
    },
    grid: {
      top: "30%",
      left: "1%",
      right: "1%",
      bottom: "5%",
      containLabel: true,
    },
    yAxis: [
      {
        type: "category",
        axisLine: {
          show: true,
          lineStyle: {
            color: "#093E95",
            width: 1,
          },
        },
        boundaryGap: true,
        axisLabel: {
          textStyle: {
            color: "#9FBAFD",
            fontSize: 12,
            margin: 15,
          },
          formatter: (xName) => {
            let name;
            if (xName.indexOf(" (kg/吨钢") > -1) {
              name = xName.replace(" (kg/吨钢)", "");
            } else {
              name = xName.replace(" (t/吨钢)", "");
            }
            return name;
          },
        },
        axisTick: {
          show: false,
        },
        data: xData,
      },
    ],
    xAxis: [
      {
        // name: '单位：次',
        nameTextStyle: {
          fontSize: 14,
          color: "#9FBAFD",
          padding: [0, 0, 0, 20],
        },
        type: "value",
        min: 0,
        // minInterval: 50,
        splitLine: {
          show: false,
          lineStyle: {
            color: "#093E95",
            width: 0.3,
          },
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#093E95",
            width: 1,
          },
        },
        axisLabel: {
          margin: 10,
          textStyle: {
            color: "#9FBAFD",
            fontSize: 12,
          },
        },
        axisTick: {
          show: false,
        },
      },
    ],
    series: [
      {
        name: "本厂",
        type: "bar",
        barMaxWidth: "20%",
        itemStyle: {
          barBorderRadius: [3, 3, 0, 0],
          color: new echarts.graphic.LinearGradient(
            0,
            0,
            0,
            1,
            [
              {
                offset: 0,
                color: "#A8FFA4",
              },
              {
                offset: 1,
                color: "#28CFFF",
              },
            ],
            false
          ),
        },
        data: y1Data,
      },
      {
        name: "行业平均值",
        type: "bar",
        barMaxWidth: "20%",
        itemStyle: {
          barBorderRadius: [3, 3, 0, 0],
          color: new echarts.graphic.LinearGradient(
            0,
            0,
            0,
            1,
            [
              {
                offset: 0,
                color: "#F0B58E",
              },
              {
                offset: 1,
                color: "#FFDAB7",
              },
            ],
            false
          ),
        },
        data: y2Data,
      },
    ],
  };
}

export default getOpt;
